import React from 'react';
import NoteForm from './NoteForm';

const CreateNote = () => {
  return <NoteForm isEdit={false} />;
};

export default CreateNote;
